import React, {useRef} from 'react';
import AccessoryCardWithButton from '../../AccessoryCardWithButton';
import {CurrencyFormat} from '../../../../utils';
import Slider from "react-slick";

import useConfiguratorData from '../../../hooks/useConfiguratorData';
import useAccessoriesData from '../../../hooks/useAccessoriesData';

const ModalAccessoriesBody = ({onCloseModal}) => {

    const { getSummary } = useConfiguratorData();
    const { getAccessories, getCategories, checkAddedAccessory, setSelectedAccessory, getFilteredAccessories, getSelectedFilter, setSelectedFilter, setFilteredAccessories } = useAccessoriesData();

    const summary = getSummary();
    const accessories = getAccessories();
    const categories = getCategories();
    const filteredAccessories = getFilteredAccessories();
    const selectedFilter = getSelectedFilter();

    const slider = useRef(null);

    const settings = {
        arrows: false,
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    infinite: false
                }
            }
        ]
    };

    const filterAccessories = category => {
        setSelectedFilter(category);
        if (category == "Todos") setFilteredAccessories(accessories);
        else setFilteredAccessories(accessories.filter(item => item.category == category));
    }

    const getCategoryAmount = category => {
        const accessories = getAccessories();
        if (category === 'Todos') {
            return accessories.length
        } else {
            return accessories.filter(accessory => accessory.category === category).length;
        }
    }

    return (
        <div className="modal-box modal-accessories-list">
            <div className="close-button icon close" id="close-modal" onClick={onCloseModal}></div>
            <div className="modal-header">
                <div className="modal-title">
                    <div className="left-title">
                        <h1>Accesorios</h1>
                        <p>Selecciona todos los que necesites</p>
                    </div>
                    <div className="right-title">
                        {summary.accessories > 0 ? (
                            <>
                                <h1>Total {CurrencyFormat(summary.accessories)}</h1>
                                <small>Monto de los accesorios seleccionados</small>
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
            <div className="modal-body">
                    <>
                        <div className="categories">
                            {categories.map(category => (
                                <button className={"btn category " + (selectedFilter == category.name ? "active" : "")} key={`category-${category}`} onClick={() => filterAccessories(category)}>{category} ({getCategoryAmount(category)})</button>
                            ))}
                        </div>
                        <div className="modal-accessories-container">
                            {filteredAccessories.length && 
                                <Slider ref={slider} {...settings}>
                                    {filteredAccessories.map(accessory => (
                                        <AccessoryCardWithButton accessory={accessory} onClickDetail={() => setSelectedAccessory(accessory)} onClickAdd={(accessory) => checkAddedAccessory(accessory)} key={`accessory-${accessory.id}`}/>
                                    ))}
                                </Slider>
                            }
                        </div>
                    </>
            </div>
            <div className="modal-footer">
                <button className="btn black" onClick={onCloseModal}>Continuar</button>
            </div>
        </div>
    )
}

export default ModalAccessoriesBody;